const setup = () => {
  handleSkipLink();
};

const handleSkipLink = () => {
  const skipTo = document.querySelector('a.skip-to-content');
  if (!skipTo) return;

  skipTo.addEventListener('click', (e) => {
    const targetId = skipTo.getAttribute('href').replace('#', '');
    const target = document.getElementById(targetId);
    if (!target) return;

    e.preventDefault();
    target.focus();
  });
};

export { setup };
